window.DLFThemeText=window.DLFThemeText||(value=>value);
/* Tracked inventory only: cart quantities share one stock allowance per variant. */
(() => {
  'use strict';
  if (window.DLFStock) return;
  let currentCart = null;
  const thai = () => (document.documentElement.lang || 'th').startsWith('th');
  function allowance(input, cart = currentCart) {
    const d = input.dataset;
    const stock = Math.max(0, Number(d.stockQuantity) || 0);
    const min = Math.max(1, Number(d.stockMin) || 1);
    const step = Math.max(1, Number(input.step) || 1);
    const same = (cart?.items || []).filter(item => String(item.variant_id || item.id) === d.stockVariant);
    const inCart = cart ? same.reduce((sum, item) => sum + Number(item.quantity || 0), 0) : Number(d.stockCart || 0);
    const line = d.key ? same.find(item => item.key === d.key) : null;
    const own = d.key ? (cart ? Number(line?.quantity || 0) : Number(d.stockOwn || 0)) : 0;
    const ceiling = d.stockRuleMax ? Math.min(stock, Number(d.stockRuleMax)) : stock;
    const remaining = Math.max(0, ceiling - inCart + own);
    const max = remaining < min ? 0 : min + Math.floor((remaining - min) / step) * step;
    return { min, step, max, inCart, stock };
  }
  function update(input, clamp = false) {
    const a = allowance(input);
    const cartLine = input.hasAttribute('data-cart-quantity');
    const blocked = a.max < a.min;
    input.min = String(blocked ? 0 : a.min);
    input.max = String(a.max);
    input.readOnly = blocked;
    if (!cartLine || clamp) {
      const number = Number(input.value);
      const value = blocked ? 0 : Math.max(a.min, Math.min(a.max, a.min + Math.floor(((Number.isFinite(number) ? number : a.min) - a.min) / a.step) * a.step));
      if (input.value !== String(value)) input.value = String(value);
    }
    const busy = input.closest('[aria-busy="true"]');
    input.closest('.quantity-control')?.querySelectorAll('[data-quantity-step]').forEach(button => {
      button.disabled = Boolean(busy) || (Number(button.dataset.quantityStep) > 0
        ? blocked || Number(input.value) + a.step > a.max
        : blocked || Number(input.value) <= a.min);
    });
    if (!cartLine) {
      const form = input.closest('[data-product-form]');
      if (form) {
        const buttons = [...form.querySelectorAll('[type="submit"]')];
        if (form.id) document.querySelectorAll('button[form]').forEach(button => { if (button.getAttribute('form') === form.id) buttons.push(button); });
        buttons.forEach(button => { button.disabled = Boolean(busy) || blocked || input.dataset.stockAvailable === 'false'; });
        form.querySelectorAll('.shopify-payment-button').forEach(payment => { payment.hidden = blocked; });
      }
    }
  }
  function sync(cart) {
    if (cart?.items) currentCart = cart;
    document.querySelectorAll('input[data-stock-quantity]').forEach(input => update(input));
    document.querySelectorAll('[data-stock-note-variant]').forEach(note => {
      if (!currentCart) return;
      const quantity = currentCart.items.filter(item => String(item.variant_id || item.id) === note.dataset.stockNoteVariant).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      const text = quantity ? (thai() ? ` · ในตะกร้า ${quantity} ชิ้น` : window.DLFThemeText(` · ${quantity} in cart`)) : '';
      if (note.textContent !== text) note.textContent = text;
    });
  }
  function assertQuantity(input, quantity, cart) {
    if (!input?.hasAttribute('data-stock-quantity')) return;
    const a = allowance(input, cart);
    if (!Number.isSafeInteger(quantity) || quantity < a.min || quantity > a.max || (quantity - a.min) % a.step !== 0) {
      throw new Error(thai()
        ? (a.max ? `เพิ่มได้อีกไม่เกิน ${a.max} ชิ้น โดยนับสินค้าที่อยู่ในตะกร้าแล้ว` : 'สินค้าที่มีอยู่ถูกเพิ่มในตะกร้าครบแล้ว ไม่สามารถเพิ่มได้อีก')
        : (a.max ? window.DLFThemeText(`You can add up to ${a.max} more, after counting items already in your cart.`) : window.DLFThemeText('All available stock is already in your cart.')));
    }
  }
  window.DLFStock = { allowance, sync, assertQuantity };
  const onQuantity = event => {
    const input = event.target.closest?.('input[data-stock-quantity]');
    if (!input) return;
    // Allow temporarily clearing a field while typing. Clamp excess immediately.
    if (event.type === 'change' || (input.value !== '' && Number(input.value) > allowance(input).max)) update(input, true);
    else if (input.value !== '') update(input);
  };
  document.addEventListener('input', onQuantity, true);
  document.addEventListener('change', onQuantity, true);
  document.addEventListener('delifresh:cart-updated', event => sync(event.detail?.cart));
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; sync(); });
  };
  const start = () => {
    sync();
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('input[data-stock-quantity]') || node.querySelector?.('input[data-stock-quantity]'))))) schedule();
    }).observe(document.body, {childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

(() => {
  'use strict';
  if (document.documentElement.dataset.delifreshReady) return;
  document.documentElement.dataset.delifreshReady = 'true';
  const returnFocus = new WeakMap();
  let activeSpecialConditionTrigger = null;
  let purchasedProductIds;

  function getPurchasedProductIds() {
    if (purchasedProductIds) return purchasedProductIds;
    const source = document.getElementById('DlfPurchasedProductIds');
    if (!source) return new Set();
    try {
      purchasedProductIds = new Set(JSON.parse(source.textContent).map(String));
    } catch (_error) {
      purchasedProductIds = new Set();
    }
    return purchasedProductIds;
  }

  function updatePurchasedProductBadges(scope = document) {
    const purchasedIds = getPurchasedProductIds();
    if (!purchasedIds.size) return;
    const products = scope.matches?.('[data-purchased-product][data-product-id]')
      ? [scope]
      : [...scope.querySelectorAll?.('[data-purchased-product][data-product-id]') || []];
    products.forEach((productElement) => {
      const badge = productElement.querySelector('[data-purchased-product-badge]');
      if (!badge) return;
      const purchased = purchasedIds.has(productElement.dataset.productId);
      badge.hidden = !purchased;
      productElement.classList.toggle('product-card--purchased', purchased);
    });
  }

  function closeSpecialCondition({ restoreFocus = true } = {}) {
    const balloon = document.getElementById('SpecialConditionBalloon');
    if (!balloon || balloon.hidden) return;
    balloon.hidden = true;
    balloon.querySelector('[data-special-condition-balloon-content]')?.replaceChildren();
    activeSpecialConditionTrigger?.setAttribute('aria-expanded', 'false');
    if (restoreFocus && activeSpecialConditionTrigger?.isConnected)
      activeSpecialConditionTrigger.focus({ preventScroll: true });
    activeSpecialConditionTrigger = null;
  }

  function positionSpecialCondition(trigger, balloon) {
    const gap = 10;
    const edge = 12;
    const triggerRect = trigger.getBoundingClientRect();
    const balloonRect = balloon.getBoundingClientRect();
    const maxLeft = Math.max(edge, window.innerWidth - balloonRect.width - edge);
    const left = Math.min(Math.max(triggerRect.left, edge), maxLeft);
    const roomAbove = triggerRect.top - balloonRect.height - gap;
    const top = roomAbove >= edge
      ? roomAbove
      : Math.min(triggerRect.bottom + gap, window.innerHeight - balloonRect.height - edge);
    balloon.style.left = `${left}px`;
    balloon.style.top = `${Math.max(edge, top)}px`;
  }

  function openSpecialCondition(trigger) {
    const source = trigger
      .closest('.special-condition-trigger-wrap')
      ?.querySelector('[data-special-condition-content]');
    const balloon = document.getElementById('SpecialConditionBalloon');
    const target = balloon?.querySelector('[data-special-condition-balloon-content]');
    if (!(source instanceof HTMLTemplateElement) || !balloon || !target) return;

    if (activeSpecialConditionTrigger === trigger && !balloon.hidden) {
      closeSpecialCondition();
      return;
    }
    closeSpecialCondition({ restoreFocus: false });
    target.replaceChildren(source.content.cloneNode(true));
    activeSpecialConditionTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    balloon.hidden = false;
    requestAnimationFrame(() => {
      positionSpecialCondition(trigger, balloon);
      balloon.focus({ preventScroll: true });
    });
  }

  document.addEventListener('click', (event) => {
    const specialConditionTrigger = event.target.closest('[data-special-condition-trigger]');
    if (specialConditionTrigger) {
      event.preventDefault();
      openSpecialCondition(specialConditionTrigger);
    }
    if (event.target.closest('[data-special-condition-close]')) closeSpecialCondition();
    const open = event.target.closest('[data-open-dialog]');
    if (open) {
      const dialog = document.getElementById(open.dataset.openDialog);
      if (dialog && !dialog.open) {
        returnFocus.set(dialog, open);
        dialog.showModal();
      }
    }
    const close = event.target.closest('[data-close-dialog]');
    if (close) close.closest('dialog')?.close();
    if (event.target instanceof HTMLDialogElement) {
      const rect = event.target.getBoundingClientRect();
      if (
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom
      )
        event.target.close();
    }
    const step = event.target.closest('[data-quantity-step]');
    if (step) {
      const input = step.closest('.quantity-control')?.querySelector('input');
      if (input && !input.disabled && !step.disabled) {
        if (Number(step.dataset.quantityStep) > 0) input.stepUp();
        else input.stepDown();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    const scrollButton = event.target.closest('[data-scroll-grid]');
    if (scrollButton) {
      const grid = scrollButton.closest('.section-container')?.querySelector('[data-product-grid]');
      grid?.scrollBy({
        left: grid.clientWidth * Number(scrollButton.dataset.scrollGrid),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    }
    document.querySelectorAll('.localization[open], .desktop-nav details[open]').forEach((detail) => {
      if (!detail.contains(event.target)) detail.open = false;
    });
    const balloon = document.getElementById('SpecialConditionBalloon');
    if (
      balloon &&
      !balloon.hidden &&
      !balloon.contains(event.target) &&
      !event.target.closest('[data-special-condition-trigger]')
    )
      closeSpecialCondition({ restoreFocus: false });
  });
  document.addEventListener(
    'close',
    (event) => {
      const trigger = returnFocus.get(event.target);
      if (trigger?.isConnected) trigger.focus();
    },
    true,
  );
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSpecialCondition();
      document.querySelectorAll('.localization[open], .desktop-nav details[open]').forEach((detail) => {
        detail.open = false;
        detail.querySelector('summary')?.focus();
      });
    }
  });
  window.addEventListener('resize', () => closeSpecialCondition({ restoreFocus: false }));
  window.addEventListener(
    'scroll',
    (event) => {
      const balloon = document.getElementById('SpecialConditionBalloon');
      if (balloon?.contains(event.target)) return;
      closeSpecialCondition({ restoreFocus: false });
    },
    { capture: true, passive: true },
  );
  const loadedScripts = new Set(
    [...document.scripts].filter((script) => script.src).map((script) => script.src),
  );
  function initialize(scope) {
    updatePurchasedProductBadges(scope);
    scope.querySelectorAll('.footer-menu').forEach((el) => {
      el.open = !matchMedia('(max-width: 749px)').matches;
    });
    // Theme Editor can add a section whose component was not present on initial load.
    scope.querySelectorAll('script[src]').forEach((source) => {
      if (loadedScripts.has(source.src)) return;
      loadedScripts.add(source.src);
      const script = document.createElement('script');
      script.src = source.src;
      script.defer = true;
      script.addEventListener('error', () => loadedScripts.delete(source.src), { once: true });
      document.head.append(script);
    });
  }
  initialize(document);
  const purchasedBadgeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) updatePurchasedProductBadges(node);
      });
    });
  });
  purchasedBadgeObserver.observe(document.body, { childList: true, subtree: true });
  const mobile = matchMedia('(max-width: 749px)');
  mobile.addEventListener('change', () => initialize(document));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const parent = event.target.closest('details');
    if (parent) parent.open = true;
    event.target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
  });
})();

(() => {
  const root = (document.body.dataset.root || '/').replace(/\/$/, '');
  const servicePaths = new Set(['/apps/personal-shopper', '/apps/dlf-rewards', '/pages/sell-with-delifresh']);
  const storeHosts = new Set([location.hostname, 'delifresh.co.th', 'www.delifresh.co.th', 'delifresheu.com', 'www.delifresheu.com']);
  function localizeServiceLinks(scope) {
    const links = scope.matches?.('a[href]') ? [scope] : [...scope.querySelectorAll?.('a[href]') || []];
    links.forEach((link) => {
      let url;
      try { url = new URL(link.getAttribute('href'), location.href); } catch (_) { return; }
      if (!['https:', 'http:'].includes(url.protocol) || !storeHosts.has(url.hostname)) return;
      const path = url.pathname.replace(/^\/en(?=\/)/, '').replace(/\/$/, '');
      if (!servicePaths.has(path)) return;
      const localized = root + path + url.search + url.hash;
      if (link.getAttribute('href') !== localized) link.setAttribute('href', localized);
    });
  }
  localizeServiceLinks(document);
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') localizeServiceLinks(mutation.target);
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) localizeServiceLinks(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
})();

// DLF Cashback badges: display-only; eligibility and settlement remain with the app.
(() => {
  'use strict';
  if (window.dlfCashbackBadgesReady) return;
  window.dlfCashbackBadgesReady = true;
  const endpoint = 'https://cashback.delifresheu.com/public/cashback-rules?shop=aqfqcu-mz.myshopify.com';
  const images = {"1":"https://cdn.shopify.com/s/files/1/0678/9709/8407/files/dlf-cashback-1percent.png?v=1791116051","2":"https://cdn.shopify.com/s/files/1/0678/9709/8407/files/dlf-cashback-2percent.png?v=1791116051","3":"https://cdn.shopify.com/s/files/1/0678/9709/8407/files/dlf-cashback-3percent.png?v=1791116052","4":"https://cdn.shopify.com/s/files/1/0678/9709/8407/files/dlf-cashback-4percent.png?v=1791116051","5":"https://cdn.shopify.com/s/files/1/0678/9709/8407/files/dlf-cashback-5percent.png?v=1791116051"};
  const blankImage = 'https://cdn.shopify.com/s/files/1/0678/9709/8407/files/dlf-cashback-dynamic.png?v=1791116299';
  const english = !document.documentElement.lang.toLowerCase().startsWith('th');
  const condition = english ? window.DLFThemeText('Eligible manual payment methods only') : 'เฉพาะช่องทางโอนเงินที่ร่วมรายการ';
  const netNotice = english ? window.DLFThemeText('Calculated on eligible merchandise after discounts.') : 'คำนวณจากยอดสินค้าที่ร่วมรายการหลังหักส่วนลด';
  const cacheKey = 'dlf-cashback-rules-v1';
  let rules = null;

  function validRules(value) {
    if (!value || value.schemaVersion !== 1 || typeof value.enabled !== 'boolean' || value.condition !== 'MANUAL_PAYMENT' || value.currency !== 'THB') return false;
    if (!['LEGACY_PERCENT', 'WEIGHT'].includes(value.mode) || !Array.isArray(value.excludedProductIds) || value.excludedProductIds.length > 5000) return false;
    if (!value.excludedProductIds.every(id => typeof id === 'string' && /^gid:\/\/shopify\/Product\/\d+$/.test(id))) return false;
    if (value.exclusionVersion !== undefined && value.exclusionVersion !== 2) return false;
    if (value.excludedVariantIds !== undefined && (!Array.isArray(value.excludedVariantIds) || value.excludedVariantIds.length > 5000 || !value.excludedVariantIds.every(id => typeof id === 'string' && /^gid:\/\/shopify\/ProductVariant\/\d+$/.test(id)))) return false;
    for (const key of ['excludedProductTypes', 'excludedVendors', 'excludedTags']) {
      if (value[key] !== undefined && (!Array.isArray(value[key]) || value[key].length > 5000 || !value[key].every(v => typeof v === 'string' && v.trim() && v.length <= 500))) return false;
    }
    if (value.overrideVersion !== undefined && value.overrideVersion !== 1) return false;
    for (const key of ['productOverrides', 'variantOverrides']) {
      if (value[key] === undefined) continue;
      if (value.overrideVersion !== 1 || !Array.isArray(value[key]) || value[key].length > 5000) return false;
      const ids = new Set();
      for (const rule of value[key]) {
        const pattern = key === 'productOverrides' ? /^gid:\/\/shopify\/Product\/\d+$/ : /^gid:\/\/shopify\/ProductVariant\/\d+$/;
        if (!rule || typeof rule.id !== 'string' || !pattern.test(rule.id) || ids.has(rule.id)) return false;
        ids.add(rule.id);
        if (key === 'variantOverrides' && (typeof rule.productId !== 'string' || !/^gid:\/\/shopify\/Product\/\d+$/.test(rule.productId))) return false;
        if (!['PERCENT', 'FIXED_THB'].includes(rule.type) || typeof rule.value !== 'number' || !Number.isFinite(rule.value) || rule.value < 0 || rule.value > (rule.type === 'PERCENT' ? 100 : 1000000)) return false;
      }
    }
    if (value.groupOverrideVersion !== undefined && value.groupOverrideVersion !== 1) return false;
    for (const key of ['tagOverrides', 'productTypeOverrides', 'vendorOverrides']) {
      if (value[key] === undefined) continue;
      if (value.groupOverrideVersion !== 1 || !Array.isArray(value[key]) || value[key].length > 5000) return false;
      const names = new Set();
      for (const rule of value[key]) {
        if (!rule || typeof rule.name !== 'string' || !rule.name.trim() || rule.name.length > 500 || /[\u0000-\u001f]/.test(rule.name)) return false;
        const name = rule.name.normalize('NFKC').trim().toLowerCase();
        if (names.has(name)) return false;
        names.add(name);
        if (!['PERCENT','FIXED_THB'].includes(rule.type) || !Number.isFinite(rule.value) || rule.value < 0 || rule.value > (rule.type === 'PERCENT' ? 100 : 1000000)) return false;
      }
    }
    if (value.mode === 'LEGACY_PERCENT') return Number.isInteger(value.percentBps) && value.percentBps >= 0 && value.percentBps <= 10000;
    if (!Array.isArray(value.tiers) || value.tiers.length > 200) return false;
    let previous = 0;
    return value.tiers.every((tier, index) => {
      if (!tier || !['PERCENT', 'FIXED_THB'].includes(tier.type) || !Number.isFinite(tier.value) || tier.value < 0 || tier.value > (tier.type === 'PERCENT' ? 100 : 1000000)) return false;
      if (tier.maxWeightGrams === null) return index === value.tiers.length - 1;
      const boundary = Math.round(tier.maxWeightGrams * 1000);
      if (typeof tier.maxWeightGrams !== 'number' || !Number.isFinite(boundary) || boundary <= previous || tier.maxWeightGrams > 1000000) return false;
      previous = boundary;
      return true;
    });
  }

  function rewardFor(feed, data) {
    if (!feed?.enabled || !data.productId || feed.excludedProductIds.includes('gid://shopify/Product/' + data.productId)) return null;
    const variants = feed.excludedVariantIds || [];
    if (variants.length && (!data.cashbackVariant || variants.includes('gid://shopify/ProductVariant/' + data.cashbackVariant))) return null;
    const normalize = value => value.normalize('NFKC').trim().toLowerCase();
    const match = (values, value) => (values || []).some(v => normalize(v) === normalize(value));
    if ((feed.excludedProductTypes || []).length && (typeof data.cashbackProductType !== 'string' || match(feed.excludedProductTypes, data.cashbackProductType))) return null;
    if ((feed.excludedVendors || []).length && (typeof data.cashbackVendor !== 'string' || match(feed.excludedVendors, data.cashbackVendor))) return null;
    if ((feed.excludedTags || []).length) {
      let tags;
      try { tags = JSON.parse(data.cashbackTags); } catch (_) { return null; }
      if (!Array.isArray(tags) || !tags.every(t => typeof t === 'string') || tags.some(t => match(feed.excludedTags, t))) return null;
    }
    const variantOverrides = feed.variantOverrides || [];
    if (variantOverrides.length && !/^\d+$/.test(data.cashbackVariant || '')) return null;
    const productId = 'gid://shopify/Product/' + data.productId;
    const variantId = 'gid://shopify/ProductVariant/' + data.cashbackVariant;
    const variantOverride = variantOverrides.find(rule => rule.id === variantId);
    if (variantOverride && variantOverride.productId !== productId) return null;
    const hasGroups = ['tagOverrides','productTypeOverrides','vendorOverrides'].some(k => feed[k]?.length);
    let tags = [];
    if (feed.tagOverrides?.length) {
      try { tags = JSON.parse(data.cashbackTags); } catch (_) { return null; }
      if (!Array.isArray(tags) || !tags.every(t => typeof t === 'string')) return null;
    }
    if ((feed.productTypeOverrides?.length && typeof data.cashbackProductType !== 'string') || (feed.vendorOverrides?.length && typeof data.cashbackVendor !== 'string')) return null;
    if ((hasGroups || variantOverrides.length || feed.productOverrides?.length) && data.cashbackGiftCard !== 'false') return null;
    const override = variantOverride || (feed.productOverrides || []).find(rule => rule.id === productId)
      || (feed.tagOverrides || []).find(rule => tags.some(tag => normalize(tag) === normalize(rule.name)))
      || (feed.productTypeOverrides || []).find(rule => normalize(rule.name) === normalize(data.cashbackProductType || ''))
      || (feed.vendorOverrides || []).find(rule => normalize(rule.name) === normalize(data.cashbackVendor || ''));

    if (override) {
      if (data.cashbackGiftCard !== 'false' || override.value <= 0 || (override.type === 'FIXED_THB' && feed.currency !== 'THB')) return null;
      return {type: override.type, value: override.value};
    }
    if (feed.mode === 'LEGACY_PERCENT') return feed.percentBps > 0 ? {type: 'PERCENT', value: feed.percentBps / 100} : null;
    const grams = Number(data.cashbackWeight);
    if (data.cashbackGiftCard === 'true' || !Number.isFinite(grams) || grams <= 0 || !data.cashbackVariant) return null;
    const mg = Math.round(grams * 1000);
    const tier = feed.tiers.find(t => t.maxWeightGrams === null || mg <= Math.round(t.maxWeightGrams * 1000));
    if (!tier || tier.value <= 0 || (tier.type === 'FIXED_THB' && feed.currency !== 'THB')) return null;
    return {type: tier.type, value: tier.value};
  }

  function renderBadge(host, data, busy = false) {
    const badgeParent = host.matches('[data-gallery]')
      ? host.querySelector('[data-cashback-gallery-footer]') || host
      : host;
    let badge = badgeParent.querySelector(':scope > .dlf-cashback-badge') || host.querySelector(':scope > .dlf-cashback-badge');
    if (badge && badge.parentElement !== badgeParent) badgeParent.append(badge);
    const reward = busy ? null : rewardFor(rules, data);
    if (!reward) { if (badge) badge.hidden = true; return; }
    const amount = reward.type === 'PERCENT' ? reward.value + '%' : '฿' + reward.value;
    const label = 'Cashback ' + amount;
    const perUnit = reward.type === 'FIXED_THB' ? (english ? window.DLFThemeText(' per item.') : ' ต่อชิ้น') : '.';
    const signature = reward.type + ':' + reward.value;
    if (!badge) {
      badge = document.createElement((host.classList.contains('product-card') || host.matches('[data-gallery]')) ? 'a' : 'span');
      if ((host.classList.contains('product-card') || host.matches('[data-gallery]'))) {
        badge.href = 'https://delifresh.co.th/pages/cashback';
        badge.target = '_blank';
        badge.rel = 'noopener noreferrer';
        badge.style.textDecoration = 'none';
      }
      badge.className = 'dlf-cashback-badge' + ((host.classList.contains('product-card') || host.matches('[data-gallery]')) ? ' dlf-cashback-footer' : '');
      badge.tabIndex = 0;
      badgeParent.append(badge);
    }
    badge.hidden = false;
    badge.removeAttribute('title');
    badge.setAttribute('aria-label', label + perUnit + ' ' + condition + '. ' + netNotice);
    if (badge.dataset.reward === signature) return;
    badge.dataset.reward = signature;
    const image = document.createElement('img');
    const exactImage = reward.type === 'PERCENT' && images[reward.value];
    image.src = (exactImage || blankImage) + '&width=160';
    image.alt = label;
    image.width = 160;
    image.height = 160;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.addEventListener('error', () => { badge.hidden = true; }, {once:true});
    const icon = document.createElement('span');
    icon.className = 'dlf-cashback-footer__icon';
    icon.append(image);
    if ((host.classList.contains('product-card') || host.matches('[data-gallery]'))) {
      const caption = document.createElement('span');
      caption.className = 'dlf-cashback-footer__caption';
      caption.textContent = english ? window.DLFThemeText('When paying by bank transfer') : 'เมื่อชำระผ่านช่องทางโอนเงินธนาคาร';
      badge.replaceChildren(icon, caption);
    } else { badge.replaceChildren(image); }
    if (!exactImage) {
      const text = document.createElement('strong');
      text.className = 'dlf-cashback-badge__amount';
      text.textContent = amount;
      text.style.fontSize = amount.length > 6 ? '10px' : amount.length > 4 ? '13px' : '18px';
      ((host.classList.contains('product-card') || host.matches('[data-gallery]')) ? icon : badge).append(text);
    }
  }

  function cashbackNetCents(priceCents, currency, reward) {
    if (!reward || !Number.isSafeInteger(priceCents) || priceCents <= 0) return null;
    let cashback;
    if (reward.type === 'PERCENT') cashback = Math.round(priceCents * reward.value / 100);
    else if (reward.type === 'FIXED_THB' && currency === 'THB') cashback = Math.round(reward.value * 100);
    else return null;
    if (!Number.isSafeInteger(cashback) || cashback <= 0) return null;
    return Math.max(0, priceCents - cashback);
  }

  function formatCashbackMoney(cents, sample) {
    const match = sample.match(/[0-9][0-9.,\u00a0\u202f ]*[0-9]/);
    if (!match || !Number.isSafeInteger(cents) || cents < 0) return null;
    const number = match[0];
    const fraction = number.match(/([.,])([0-9]{2})$/);
    const precision = fraction ? 2 : 0;
    const integerSample = fraction ? number.slice(0, -3) : number;
    const group = integerSample.match(/[^0-9]/)?.[0] || '';
    const parts = (cents / 100).toFixed(precision).split('.');
    const integer = group ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group) : parts[0];
    const formatted = integer + (precision ? fraction[1] + parts[1] : '');
    return sample.slice(0, match.index) + formatted + sample.slice(match.index + number.length);
  }

  function renderNetPrices(scope, data, busy = false) {
    if (!scope) return;
    const reward = busy ? null : rewardFor(rules, data);
    scope.querySelectorAll('[data-cashback-net-price]').forEach(line => {
      const price = line.closest('.price');
      const cents = cashbackNetCents(Number(price?.dataset.cashbackPrice), data.cashbackCurrency, reward);
      const formatted = cents === null ? null : formatCashbackMoney(cents, price.dataset.cashbackMoney || '');
      if (formatted === null) { line.hidden = true; return; }
      const prefix = line.dataset.cashbackFrom;
      const text = (prefix ? prefix + ' ' : '') + formatted;
      const value = line.querySelector('[data-cashback-net-value]');
      if (!value) { line.hidden = true; return; }
      if (value.textContent !== text) value.textContent = text;
      line.hidden = false;
    });
  }

  function update() {
    document.querySelectorAll('.product-card[data-cashback-variant]').forEach(card => {
      renderBadge(card, card.dataset);
      renderNetPrices(card, card.dataset);
    });
    document.querySelectorAll('product-detail').forEach(product => {
      const current = product.querySelector('[data-cashback-current]');
      const data = current?.dataset || {};
      const busy = product.querySelector('[data-product-core]')?.getAttribute('aria-busy') === 'true';
      const gallery = product.querySelector('[data-gallery]');
      if (gallery) renderBadge(gallery, data, busy);
      renderNetPrices(product.querySelector('[data-product-core]'), data, busy);
    });
  }

  async function loadRules() {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      try {
        const cached = JSON.parse(sessionStorage.getItem(cacheKey));
        const age = Date.now() - cached?.at;
        if (age >= 0 && age < 30000 && validRules(cached.rules)) return cached.rules;
      } catch (_) { /* Storage may be disabled. */ }
      const response = await fetch(endpoint, {signal: controller.signal, credentials:'omit', cache:'no-store'});
      if (!response.ok) throw new Error('Cashback rules unavailable');
      const feed = await response.json();
      if (!validRules(feed)) throw new Error('Invalid cashback rules');
      try { sessionStorage.setItem(cacheKey, JSON.stringify({at:Date.now(), rules:feed})); } catch (_) {}
      return feed;
    } catch (_) {
      try { sessionStorage.removeItem(cacheKey); } catch (_) {}
      return null;
    } finally { clearTimeout(timeout); }
  }
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; update(); });
  };
  new MutationObserver(mutations => {
    if (mutations.some(m => m.type === 'attributes' || [...m.addedNodes].some(n => n instanceof Element && !n.closest('.dlf-cashback-badge')))) schedule();
  }).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['aria-busy']});
  loadRules().then(feed => { rules = feed; update(); });
})();

(() => {
  let balloon;
  let active;
  let pinned = false;
  let closeTimer;
  const selector = '[data-cashback-info]';
  function close() {
    clearTimeout(closeTimer);
    if (active) {
      active.setAttribute('aria-expanded', 'false');
      active.removeAttribute('aria-describedby');
    }
    if (balloon) balloon.hidden = true;
    active = null;
    pinned = false;
  }
  function place() {
    if (!active?.isConnected || active.closest('[hidden]')) { close(); return; }
    const anchor = active.getBoundingClientRect();
    const box = balloon.getBoundingClientRect();
    const left = Math.max(12, Math.min(anchor.left + anchor.width / 2 - box.width / 2, innerWidth - box.width - 12));
    const below = anchor.bottom + 9;
    const top = below + box.height <= innerHeight - 12 ? below : Math.max(12, anchor.top - box.height - 9);
    balloon.style.left = left + 'px';
    balloon.style.top = top + 'px';
  }
  function open(button) {
    clearTimeout(closeTimer);
    if (active !== button) close();
    if (!balloon) {
      balloon = document.createElement('div');
      balloon.id = 'dlf-cashback-price-info';
      balloon.className = 'price-cashback-balloon';
      balloon.setAttribute('role', 'tooltip');
      balloon.hidden = true;
      document.body.append(balloon);
      balloon.addEventListener('pointerenter', () => clearTimeout(closeTimer));
      balloon.addEventListener('pointerleave', deferClose);
    }
    active = button;
    balloon.textContent = button.dataset.cashbackInfo;
    balloon.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    button.setAttribute('aria-describedby', balloon.id);
    place();
  }
  function deferClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => { if (!pinned && document.activeElement !== active) close(); }, 180);
  }
  document.addEventListener('pointerover', event => {
    const button = event.target.closest(selector);
    if (button && event.pointerType !== 'touch') open(button);
  });
  document.addEventListener('pointerout', event => {
    const button = event.target.closest(selector);
    if (button && !button.contains(event.relatedTarget) && !balloon?.contains(event.relatedTarget)) deferClose();
  });
  document.addEventListener('focusin', event => {
    const button = event.target.closest(selector);
    if (button) open(button);
  });
  document.addEventListener('focusout', event => {
    if (event.target.closest(selector)) deferClose();
  });
  document.addEventListener('click', event => {
    const button = event.target.closest(selector);
    if (button) {
      event.preventDefault();
      if (active === button && pinned) close();
      else { open(button); pinned = true; }
    } else if (!balloon?.contains(event.target)) close();
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
  window.addEventListener('resize', () => { if (active) place(); });
  window.addEventListener('scroll', close, {capture: true, passive: true});
})();


(() => {
  if (document.documentElement.dataset.dlfBrandSearchReady) return;
  document.documentElement.dataset.dlfBrandSearchReady = 'true';
  const normalize = value => value.normalize('NFKC').replace(/\s*\((?:พรีออเดอร์|สต๊อคเยอรมัน|สต็อกเยอรมัน|preorder|germany stock)\)\s*$/i, '').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
  const brandAliases = {"hongthai":"หงส์ไทย","vfoodsmix":"วีฟู้ดส์ มิกซ์","phuengnoi":"ผึ้งน้อย","nestlé":"เนสท์เล่","chatramue":"ชาตรามือ","nguansoon":"ง่วนสูน","lactasoy":"แลคตาซอย","lin":"ลิน","tummour":"ตำมั่ว","maeepim":"แม่อิพิม","pawaen":"ป้าแว่น","zaabmike":"แซ่บไมค์","nittaya":"น้ำพริกนิตยา","lobo":"โลโบ","yumyum":"ยำยำ","mama":"มาม่า","kinploen":"กินเพลิน","ajinomotoplus":"อายิโนะโมะโต๊ะพลัส","yummy":"ยัมมี่","bk":"บีเค","driedfruits&vegetables":"ผักและผลไม้อบกรอบ","bongnua":"บองนัว","mildy":"ไมล์ดี้","wangphromherbal":"สมุนไพรวังพรม","dreamy":"ดรีมมี่","cp":"ซีพี","newgrade":"นิวเกรด","hotta":"ฮอทต้า","rosdee":"รสดี","d-plee":"ดี-ปลี","bell":"ระฆัง","voiz":"วอยซ์","isanpasuap":"อีสานพาสวบ","chefja":"เชฟจ๋า","yodrak":"ยอดรัก","bongnuamaesa":"บองนัว แม่ส่าห์","doubledragon":"มังกรคู่","rueathong":"เรือทอง","sailboat":"เรือใบ","bansuankru":"บ้านสวนครู","kanyok":"คันโยก","nesvita":"เนสวิต้า","pumpui":"ปุ้มปุ้ย","jaetab":"เจ๊ตับ","d-neekids":"ดีนี่ คิดส์","zam-buk":"แซมบัค","bennett":"เบนเนท","wangprom":"วังพรม","mana":"มานา","kokliang":"ก๊กเลี้ยง","pond's":"พอนด์ส","o.c.":"โอซี","vida":"วีด้า","snakebrand":"ตรางู","sunsilk":"ซันซิล","ingon":"อิงอร","unes":"ยูเน่เอส","nsos":"เอ็นโซเอส","pennyo":"เพนนีโอ","aro":"เอโร่","cream-o":"ครีมโอ","poy-sian":"โป๊ยเซียน","roza":"โรซ่า","easyfood":"อี่ซี่ ฟู้ด","maepranom":"แม่ประนอม"};
  function resolveBrand(value) {
    const normalized = normalize(value);
    return brandAliases[normalized.replace(/\s/g, '')] || normalized;
  }
  function brandQuery(value) {
    const term = value.trim();
    if (!term || /[:"*]/.test(term)) return null;
    const source = document.querySelector('[data-search-vendors]');
    if (!source) return null;
    let vendors;
    try { vendors = JSON.parse(source.textContent); } catch (_) { return null; }
    if (!Array.isArray(vendors)) return null;
    const canonical = resolveBrand(term);
    const vendor = vendors.find(vendor => normalize(vendor) === normalize(canonical));
    if (!vendor) return null;
    return 'vendor:"' + normalize(vendor).replace(/\\/g, '\\\\') + '"';
  }

  // Old generated vendor links become regular searches; both result streams stay available.
  function prepareLink(link) {
    if (!(link instanceof HTMLAnchorElement)) return false;
    const form = document.querySelector('form[data-brand-search]');
    if (!form) return false;
    const url = new URL(link.href, location.href);
    const searchUrl = new URL(form.action, location.href);
    const match = (url.searchParams.get('q') || '').match(/^vendor:"([^"*]+)"$/);
    if (url.origin !== searchUrl.origin || url.pathname !== searchUrl.pathname || !match || !brandQuery(match[1])) return false;
    url.searchParams.set('q', match[1]);
    link.href = url.href;
    return true;
  }
  function mergeFacets(base, exact) {
    const baseForm = base.querySelector('.facets form');
    if (!baseForm) return;
    exact.querySelectorAll('.facets form .facet').forEach(source => {
      const key = source.querySelector('summary')?.textContent.trim();
      let target = [...baseForm.querySelectorAll('.facet')].find(node => node.querySelector('summary')?.textContent.trim() === key);
      if (!target) {
        baseForm.insertBefore(source.cloneNode(true), baseForm.querySelector('button[type="submit"]'));
        return;
      }
      source.querySelectorAll('input[type="checkbox"]').forEach(input => {
        const existing = [...target.querySelectorAll('input[type="checkbox"]')].find(node => node.name === input.name && node.value === input.value);
        if (!existing) target.querySelector('ul')?.append(input.closest('li').cloneNode(true));
        else if (!input.disabled) existing.disabled = false;
      });
      source.querySelectorAll('.price-range input').forEach(input => {
        const existing = [...target.querySelectorAll('.price-range input')].find(node => node.name === input.name);
        if (!existing || Number(existing.max) >= Number(input.max)) return;
        existing.max = input.max;
        if (Number(input.placeholder) > Number(existing.placeholder)) existing.placeholder = input.placeholder;
      });
    });
  }
  async function loadDirectBrand(page) {
    if (!page?.hasAttribute('data-brand-pending') || page.dataset.brandLoading === 'true') return;
    const content = page.querySelector('[data-search-content]');
    const original = content?.querySelector('template[data-search-original]');
    const query = brandQuery(page.dataset.searchQuery || '');
    if (!content || !original || !query || !page.dataset.searchSection) return;
    page.dataset.brandLoading = 'true';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const url = new URL(location.href);
      const brandPage = Math.max(1, Number(url.searchParams.get('brand_page')) || 1);
      url.searchParams.set('type', 'product');
      url.searchParams.set('q', query);
      url.searchParams.set('page', String(brandPage));
      url.searchParams.set('section_id', page.dataset.searchSection);
      url.searchParams.delete('brand_page');
      url.searchParams.delete('sections');
      const response = await fetch(url.href, {signal: controller.signal, credentials: 'same-origin'});
      if (!response.ok) throw new Error('Search section unavailable');
      const result = new DOMParser().parseFromString(await response.text(), 'text/html');
      const resolved = result.querySelector('[data-search-page]');
      const exact = resolved?.querySelector('[data-search-content]');
      if (!exact || resolved.hasAttribute('data-brand-pending') || resolved.dataset.searchSection !== page.dataset.searchSection) throw new Error('Invalid search section');
      const base = original.content.cloneNode(true);
      const results = base.querySelector('[data-search-results]');
      const relatedGrid = results?.querySelector('.product-grid');
      const brandGrid = exact.querySelector('.product-grid');
      if (!results || !relatedGrid || !brandGrid) throw new Error('Search grid missing');

      const term = page.dataset.searchQuery;
      const seen = new Set();
      brandGrid.querySelectorAll('.product-card').forEach(card => {
        const id = card.dataset.productId;
        if (seen.has(id)) card.remove();
        else seen.add(id);
      });
      relatedGrid.querySelectorAll('.product-card').forEach(card => {
        const id = card.dataset.productId;
        if (normalize(card.dataset.cashbackVendor || '') === normalize(resolveBrand(term)) || seen.has(id)) card.remove();
        else seen.add(id);
      });
      mergeFacets(base, exact);
      const th = document.documentElement.lang.startsWith('th');

      const brandTotalPages = Number(exact.querySelector('[data-search-results]')?.dataset.searchPages) || 1;
      const relatedTotalPages = Number(results.dataset.searchPages) || 1;
      let nextBrandPage = brandPage + 1;
      let nextRelatedPage = Math.max(1, Number(new URL(location.href).searchParams.get('page')) || 1) + 1;
      let queuedRelated = [...relatedGrid.querySelectorAll('.product-card')];
      const brandCards = [...brandGrid.querySelectorAll('.product-card')];
      brandCards.forEach(card => { card.dataset.searchMatch = 'brand'; });
      queuedRelated.forEach(card => { card.dataset.searchMatch = 'related'; });
      const hasBrandPages = () => nextBrandPage <= brandTotalPages;
      relatedGrid.replaceChildren(...brandCards);
      if (!hasBrandPages()) {
        relatedGrid.append(...queuedRelated);
        queuedRelated = [];
      }
      if (!relatedGrid.querySelector('.product-card')) {
        const empty = brandGrid.querySelector('.empty-state');
        if (empty) relatedGrid.append(empty.cloneNode(true));
      }
      results.replaceChildren(relatedGrid);
      results.dataset.searchUnified = '';
      const controls = document.createElement('div');
      controls.className = 'pagination';
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'button button--outline';
      more.dataset.searchLoadMore = '';
      controls.append(more);
      results.append(controls);
      const moreText = th ? 'แสดงสินค้าเพิ่มเติม' : window.DLFThemeText('Show more products');
      const updateMore = () => {
        controls.hidden = !hasBrandPages() && !queuedRelated.length && nextRelatedPage > relatedTotalPages;
        more.textContent = moreText;
        page.dataset.searchRenderedTotal = String(relatedGrid.querySelectorAll('.product-card').length);
        if (controls.hidden) {
          const summary = content.querySelector('.collection-toolbar > p');
          if (summary) summary.textContent = page.dataset.searchRenderedTotal + ' ' + (th ? 'ผลการค้นหา' : window.DLFThemeText('Search results')) + ': “' + term + '”';
        }
      };
      async function fetchNext(pageNumber, isBrand) {
        const target = new URL(location.href);
        target.searchParams.set('type', 'product');
        target.searchParams.set('q', isBrand ? query : term);
        target.searchParams.set('page', String(pageNumber));
        target.searchParams.set('section_id', page.dataset.searchSection);
        target.searchParams.delete('brand_page');
        target.searchParams.delete('sections');
        const requestController = new AbortController();
        const requestTimeout = setTimeout(() => requestController.abort(), 15000);
        try {
          const response = await fetch(target.href, {signal: requestController.signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error('Search section unavailable');
          const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextPage = nextDocument.querySelector('[data-search-page]');
          if (nextPage?.dataset.searchSection !== page.dataset.searchSection) throw new Error('Invalid search section');
          const native = nextPage.querySelector('template[data-search-original]')?.content || nextPage.querySelector('[data-search-content]');
          const grid = native?.querySelector('.product-grid');
          if (!grid) throw new Error('Search grid missing');
          return [...grid.querySelectorAll('.product-card')].filter(card => {
            const id = card.dataset.productId;
            if ((!isBrand && normalize(card.dataset.cashbackVendor || '') === normalize(resolveBrand(term))) || seen.has(id)) return false;
            seen.add(id);
            card.dataset.searchMatch = isBrand ? 'brand' : 'related';
            return true;
          });
        } finally {
          clearTimeout(requestTimeout);
        }
      }
      more.addEventListener('click', async () => {
        if (more.disabled) return;
        more.disabled = true;
        more.setAttribute('aria-busy', 'true');
        more.textContent = th ? 'กำลังโหลด…' : window.DLFThemeText('Loading…');
        try {
          let added = 0;
          if (hasBrandPages()) {
            const cards = await fetchNext(nextBrandPage, true);
            relatedGrid.querySelector('.empty-state')?.remove();
            relatedGrid.append(...cards);
            nextBrandPage++;
            added += cards.length;
          }
          if (!hasBrandPages() && queuedRelated.length) {
            relatedGrid.append(...queuedRelated);
            added += queuedRelated.length;
            queuedRelated = [];
          }
          while (!added && !hasBrandPages() && nextRelatedPage <= relatedTotalPages) {
            const cards = await fetchNext(nextRelatedPage, false);
            relatedGrid.querySelector('.empty-state')?.remove();
            relatedGrid.append(...cards);
            nextRelatedPage++;
            added += cards.length;
          }
          updateMore();
        } catch (_) {
          more.textContent = th ? 'ลองอีกครั้ง' : window.DLFThemeText('Try again');
        } finally {
          more.disabled = false;
          more.removeAttribute('aria-busy');
        }
      });
      updateMore();

      // A union total is exact only when both complete streams fit on one page.
      const complete = Number(results.dataset.searchPages) <= 1 && Number(exact.querySelector('[data-search-results]')?.dataset.searchPages) <= 1;
      const summary = base.querySelector('.collection-toolbar > p');
      if (summary) summary.textContent = (complete ? String(seen.size) + ' ' : '') + (th ? 'ผลการค้นหา' : window.DLFThemeText('Search results')) + ': “' + term + '”';
      content.replaceChildren(...base.childNodes);
      content.removeAttribute('aria-busy');
      page.removeAttribute('data-brand-pending');
      page.dataset.searchBlended = 'true';
      page.dataset.searchExactTotal = resolved.dataset.searchTotal;
      page.dataset.searchRenderedTotal = String(relatedGrid.querySelectorAll('.product-card').length);
      const siteName = document.title.split(' – ').slice(1).join(' – ');
      document.title = summary.textContent + (siteName ? ' – ' + siteName : '');
    } catch (_) {
      // Preserve the original search if the brand request fails, rather than hiding it.
      content.replaceChildren(original.content.cloneNode(true));
      content.removeAttribute('aria-busy');
      page.removeAttribute('data-brand-pending');
    } finally {
      clearTimeout(timeout);
      delete page.dataset.brandLoading;
    }
  }
  window.dlfBrandSearch = { prepareLink, query: brandQuery };
  document.querySelectorAll('[data-search-page][data-brand-pending]').forEach(loadDirectBrand);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-search-page][data-brand-pending]').forEach(loadDirectBrand);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link) prepareLink(link);
  }, true);
})();

/* Cart photo badges use the same canonical German product feed as product cards. */
(() => {
  'use strict';
  if (window.dlfCartPhotoBadgesReady) return;
  window.dlfCartPhotoBadgesReady = true;
  function syncCartPhotoBadges() {
    const source = window.dlfGermanStockProductTypes;
    const age = Date.now() - Date.parse(source?.generatedAt);
    const valid = source?.version === 1 && source.productType === 'สต๊อคเยอรมัน' && Array.isArray(source.productIds) && source.productIds.length <= 10000 && source.productIds.every(id => typeof id === 'string' && /^[1-9]\d*$/.test(id)) && age >= -120000 && age < 86400000;
    const ids = valid ? new Set(source.productIds.map(String)) : null;
    // English product-type translations may be stale; the shared feed uses canonical types.
    document.querySelectorAll('[data-preorder-process-product], [data-stock-process-product]').forEach(section => {
      const productId = section.dataset.preorderProcessProduct || section.dataset.stockProcessProduct;
      if (!productId) return;
      const germanStock = ids ? ids.has(productId) : section.dataset.productType?.trim() === 'สต๊อคเยอรมัน';
      section.hidden = section.hasAttribute('data-stock-process-product') ? !germanStock : germanStock;
    });
    const english = !(document.documentElement.lang || 'th').startsWith('th');
    document.querySelectorAll('[data-cart-image-badges]').forEach(stack => {
      const eligible = ids ? ids.has(stack.dataset.productId) : stack.dataset.productType?.trim() === 'สต๊อคเยอรมัน';
      let badge = stack.querySelector('[data-cart-german-badge]');
      if (!eligible) { badge?.remove(); return; }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-line__german-badge';
        badge.dataset.cartGermanBadge = '';
        const image = document.createElement('img');
        image.src = 'https://parcels.delifresheu.com/german-fast-badge-th-en-v1.webp';
        image.width = 1774;
        image.height = 887;
        image.decoding = 'async';
        badge.append(image);
        stack.prepend(badge);
      }
      badge.dataset.language = english ? 'en' : 'th';
      badge.querySelector('img').alt = english ? window.DLFThemeText('Fast delivery from our German warehouse') : 'ส่งไว จากคลังเยอรมัน';
    });
  }
  document.addEventListener('delifresh:cart-updated', syncCartPhotoBadges);
  // The existing shared service refreshes this public, canonical product feed.
  document.addEventListener('load', event => {
    if (event.target.tagName === 'SCRIPT' && event.target.src.includes('/german-stock-products-v1.js')) syncCartPhotoBadges();
  }, true);
  const start = () => {
    syncCartPhotoBadges();
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-cart-image-badges], [data-preorder-process-product], [data-stock-process-product]') || node.querySelector?.('[data-cart-image-badges], [data-preorder-process-product], [data-stock-process-product]'))))) syncCartPhotoBadges();
    }).observe(document.body, {childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
